<!--
 * @Author: your name
 * @Date: 2020-04-14 08:54:09
 * @LastEditTime: 2020-04-14 09:01:12
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \zlonmarinesite\src\components\contentcoms\newscontentcoms\news12.vue
 -->
<!--
 * @Author: your name
 * @Date: 2020-04-14 08:39:13
 * @LastEditTime: 2020-04-14 08:53:16
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \zlonmarinesite\src\components\contentcoms\newscontentcoms\news11.vue
 -->
<template>
  <div class="body-width divcss5">
    <div>
      <div class="div-row div-bottom news-Medium-24">
        海大智龙携手“航海教育实训线上平台”共抗新冠
        <!-- <span class="news-Regular-14">作者：何舒 来源：科技处 添加时间：2019-05-09 09:13:27</span> -->
      </div>
      <div class="div-text-left news-Regular-14b6">
        <span>2020-04-13</span><span class="div-padding-left">大连海大智龙科技有限公司</span>
      </div>
      <div class="div-line  divcss5">

      </div>
      <div class="div-row div-bottom30">
        <p class="indentation">
          海大智龙为应对疫情对海事院校实操培训的影响，现隆重推出线上航海教育实训平台，疫情期间免费试用，请登录海大智龙官网www.zlonmarine.com产品中心选用陆续推出的相关实训模拟软件:包括四个典型船型实船配载软件，船舶操纵与避碰虚拟仿真实训平台，JRC-9100雷达-ARPA模拟软件，ECDIS模拟软件，GMDSS模拟软件，操纵避碰模拟考试软件，号灯号型模拟考试软件等，并期待您能留下宝贵的意见和建议。
        </p>
        <img src="static/imgts/news12/01.png" />
        <img src="static/imgts/news12/02.png" />
        <img src="static/imgts/news12/03.png" />
        <img src="static/imgts/news12/04.png" />
        <img src="static/imgts/news12/05.png" />
        <img src="static/imgts/news12/06.png" />
        <img src="static/imgts/news12/07.png" />
        <img src="static/imgts/news12/08.png" />
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        isflag1: true,
        isflag2: false,
        isflag3: false
      };
    },
    mounted() {
      window.addEventListener('scroll', this.handleScroll)
    },
    methods: {
      handleScroll() {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        if (parseInt(scrollTop) >= 550 && parseInt(scrollTop) < 1200) {
          // alert(scrollTop)
          this.isflag2 = true;
        }
        if (parseInt(scrollTop) >= 1200) {
          this.isflag3 = true;
        }

      },
      destroyed() {
        window.removeEventListener('scroll', this.handleScroll)
      },
    },
  };

</script>

<style scoped>
  img {
    margin-top: 30px;
  }

  .fl {
    float: right;
    margin-right: 20px;
  }

  .fy {
    text-align: center;
    margin-top: 30px;
  }

  .title {
    height: 100%;
  }

  .div-width {
    width: 75%;
  }



  .div-line {
    background: #E6E6E6;
    height: 1px;
    width: 100%;

  }

  .div-bottom10 {
    padding-top: 10px;
  }

  .div-bottom30 {
    padding-top: 30px;
    padding-bottom: 30px;
  }

  .div-top30 {
    padding-top: 30px;
  }

  .div-padding-left {
    padding-left: 36px;
  }

  .div-top30 {
    margin-top: 30px;
  }

  .div-top0 {
    margin-bottom: 0px !important;
  }
  
  img {
    vertical-align: middle;
    border-style: none;
    width: 100%; 
  }
</style>



// WEBPACK FOOTER //
// src/components/contentcoms/news2020/news12.vue